import isEmpty from 'lodash/isEmpty'

export const protectSetValue = (oldData, newData) => {
  if (isEmpty(newData)) return oldData
  return newData
}